import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/nav";
import FrontPage from "./components/Frontpagecomponents/frontpage"; // Import your next page
import Footer from "./components/Frontpagecomponents/footer";
// import Preparepage from "./Pages/Preparepage";
import Secpage from "./Pages/secpage";
// // import LeetCodeInputPage from "./components/Homepage/leetcode";
// import Profile from "./components/Homepage/Profile";
import LeetCodeInputPage from "./components/Homepage/leetcode";
// import ProfilePage from "./components/Homepage/Profilepage";
import Register from "./components/Profile,login,reg/Register";
import Login from "./components/Profile,login,reg/Login";
import Community from "./components/Community/interface";
import ChatWithGpt from "./components/Pages/ChatBot";
// import ProfilePage from "./components/Profile,login,reg/Profilepage";

function App() {
  return (
    <Router>
      <div className="bg-[#222831] min-h-screen">
        <Nav />
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/problems" element={<Secpage/>} />
          <Route path="/chat" element={<ChatWithGpt/>}/>
          {/* <Route path="/prepare" element={<Preparepage/>} /> */}
          <Route path="/profile" element={<LeetCodeInputPage/>}/>
          <Route path="/register" element={<Register/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/communities" element={<Community/>}/>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
